import * as React from 'react'
import { PremiumLabel } from '@lacedltd/laced-components'
import { useEstimatedDeliveryDate, useTranslation } from 'hooks'
import { withTranslations } from 'helpers'
import PremiumDeliveryCountdown from '../../shared/PremiumDeliveryCountdown'
import * as S from './ProductDeliveryLabel.styles'

const ProductDeliveryLabel = ({
  visible,
  groupType
}: {
  visible: boolean
  groupType: string
}) => {
  const { t } = useTranslation()
  const { error, remainingTime } = useEstimatedDeliveryDate()
  const previousVisibleState = React.useRef(visible)
  const [animate, setAnimate] = React.useState(false)

  React.useEffect(() => {
    // only animate if the user changes size, and premium ship availability changes
    // prevents an animation going off when first loading the page
    if (previousVisibleState.current !== visible) {
      setAnimate(true)
      previousVisibleState.current = visible
    }
  }, [visible])

  if (!remainingTime || error) return null

  return (
    <S.ProductDeliveryAnimation visible={visible} animate={animate}>
      <S.ProductDeliveryLabel data-testid="product-delivery-label">
        <S.ProductDeliveryTextWrap>
          <S.EstimatedDeliveryText variant="body" data-text="tomorrow">
            <PremiumDeliveryCountdown
              type="short"
              isPdp={true}
              groupType={groupType}
            />
          </S.EstimatedDeliveryText>
          <PremiumLabel value={t('shared.premium.title')} size="m" />
        </S.ProductDeliveryTextWrap>
        <S.PremiumDeliveryAvailableText variant="footnote">
          {t('shared.premium.available')}
        </S.PremiumDeliveryAvailableText>
      </S.ProductDeliveryLabel>
    </S.ProductDeliveryAnimation>
  )
}

export default withTranslations(ProductDeliveryLabel)
